import PropTypes from 'prop-types';
import { Grid, Typography, Stack } from '@mui/material';
import { Link } from 'react-router-dom';
import {
    CLUB_ADDRESS,
    SUPPORT_PHONE,
    SUPPORT_PHONE_TEL,
    SUPPORT_EMAIL,
    SUPPORT_EMAIL_MAILTO,
} from '../../../config/contact';

function FooterLinkColumn({ title, links }) {
    return (
        <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: 'grey.100' }}>
                {title}
            </Typography>
            <Stack spacing={1}>
                {links.map((link) => (
                    <Typography
                        key={link.label}
                        component={Link}
                        to={link.path}
                        variant="body2"
                        sx={{
                            color: 'grey.400',
                            textDecoration: 'none',
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'white',
                            },
                        }}
                    >
                        {link.label}
                    </Typography>
                ))}
            </Stack>
        </Grid>
    );
}

FooterLinkColumn.propTypes = {
    title: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
    })).isRequired,
};

function FooterContactColumn() {
    return (
        <Grid size={{ xs: 6, sm: 4, md: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 2, color: 'grey.100' }}>
                Contact
            </Typography>
            <Stack spacing={1}>
                <Typography variant="body2" sx={{ color: 'grey.400' }}>
                    {CLUB_ADDRESS}
                </Typography>
                <Typography
                    component="a"
                    href={SUPPORT_PHONE_TEL}
                    variant="body2"
                    sx={{
                        color: 'grey.400',
                        textDecoration: 'none',
                        '&:hover': { color: 'white' },
                    }}
                >
                    {SUPPORT_PHONE}
                </Typography>
                <Typography
                    component="a"
                    href={SUPPORT_EMAIL_MAILTO}
                    variant="body2"
                    sx={{
                        color: 'grey.400',
                        textDecoration: 'none',
                        '&:hover': { color: 'white' },
                    }}
                >
                    {SUPPORT_EMAIL}
                </Typography>
            </Stack>
        </Grid>
    );
}

export function FooterLinksSection({ quickLinks, programLinks, filteredResourceLinks }) {
    return (
        <>
            <FooterLinkColumn title="Quick Links" links={quickLinks} />
            <FooterLinkColumn title="Programs" links={programLinks} />
            <FooterLinkColumn title="Resources" links={filteredResourceLinks} />
            <FooterContactColumn />
        </>
    );
}

FooterLinksSection.propTypes = {
    quickLinks: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
    })).isRequired,
    programLinks: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
    })).isRequired,
    filteredResourceLinks: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
    })).isRequired,
};

export default FooterLinksSection;
